module.exports = __webpack_public_path__ + "img/V11.61d4bab8.png";